import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { List } from 'immutable'
import SelectList from 'components/common/SelectList'
import {
  setActiveLogbook,
  fetchDbLogbookEventList,
  clearLogbookData,
} from 'reducers/dataBrowser/reducer'
import messages from '../../translate'

class LogBookData extends Component {
  componentDidMount() {
    const {
      activeSite,
      activeLocus,
      activeLocusGroup,
      fetchDbLogbookEventList,
    } = this.props
    const isLocusGroupCheck = activeLocusGroup ? 'locus_group' : 'site'
    fetchDbLogbookEventList({
      site: activeSite,
      level: activeLocus ? 'locus' : isLocusGroupCheck,
    })
  }

  componentDidUpdate(prevProps) {
    const {
      activeSite,
      activeLocus,
      activeLocusGroup,
      fetchDbLogbookEventList,
    } = this.props

    if (
      prevProps.activeSite !== activeSite ||
      prevProps.activeLocus !== activeLocus ||
      prevProps.activeLocusGroup !== activeLocusGroup
    ) {
      const isLocusGroupCheck = activeLocusGroup ? 'locus_group' : 'site'
      fetchDbLogbookEventList({
        site: activeSite,
        level: activeLocus ? 'locus' : isLocusGroupCheck,
      })
    }
  }

  onLogbookChange = data => {
    const { activeLogbook, setActiveLogbook, clearLogbookData } = this.props
    if (data !== undefined && data.index !== activeLogbook.get('id')) {
      if (data.index !== 0) {
        setActiveLogbook(data.item)
      } else {
        clearLogbookData()
      }
    }
  }

  render() {
    const {
      intl: { formatMessage },
      logbookList,
      activeLogbook,
    } = this.props
    const eventList = logbookList.toArray().map(event => ({
      id: event.id,
      name: event.title,
    }))
    eventList.unshift({ id: 0, name: formatMessage(messages.unselectAll) })

    return (
      <SelectList
        name="logbook_data"
        label={formatMessage(messages.logbookData)}
        onChange={this.onLogbookChange}
        list={List(eventList)}
        value={activeLogbook.get('id')}
        disabled={Boolean(eventList.length === 0)}
        map={{
          index: 'id',
          text: 'name',
        }}
      />
    )
  }
}

export default connect(
  state => ({
    activeSite: state.getIn(['profile', 'siteId']),
    activeLocus: state.getIn(['dataBrowser', 'activeLocus']),
    activeLocusGroup: state.getIn(['dataBrowser', 'activeLocusGroup']),
    logbookList: state.getIn(['dataBrowser', 'logbookEventList']),
    activeLogbook: state.getIn(['dataBrowser', 'activeLogbookType']),
  }),
  {
    setActiveLogbook,
    fetchDbLogbookEventList,
    clearLogbookData,
  },
)(injectIntl(LogBookData))
